// extracted by mini-css-extract-plugin
export default {"select":"enter-form-body_select"};